/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SkumapTemplateRequest } from '../../models/skumap-template-request';

export interface SkumapTemplatesTemplateIdPut$Params {
  'Active-Tenant-Identifier': string;
  templateId: string;
      body: SkumapTemplateRequest
}

export function skumapTemplatesTemplateIdPut(http: HttpClient, rootUrl: string, params: SkumapTemplatesTemplateIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, skumapTemplatesTemplateIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('templateId', params.templateId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

skumapTemplatesTemplateIdPut.PATH = '/skumap/templates/{templateId}';
